// Where the OAuth `state` waits between leaving for the provider and coming
// back. sessionStorage, not localStorage: it belongs to this tab and this
// sign-in attempt, and must not outlive either.
//
// Shared by the login page (writes it) and the callback page (reads and clears
// it) so the two cannot drift onto different keys — which would fail as a
// state mismatch on every single sign-in.
export const STATE_STORAGE_KEY = "federatedLoginState";

// The provider's display name from the button that was pressed, for the
// refusals that send the person back to fix something there ("add an email in
// your bilorg profile"). The callback route only carries the slug.
export const PROVIDER_NAME_STORAGE_KEY = "federatedLoginProvider";
